import React from "react";
import styled from "styled-components";

const StyledLabel = styled.label`
color: #535559;
font-family: "Inter";
font-size: 16px;
font-weight: 500;
`;
//for styled label
const FormikLabel = ({ name, children, ...restProps }) => {
  return (
    <StyledLabel  className="form-label" htmlFor={name} {...restProps}>
      {children}
    </StyledLabel>
  );
};

export default FormikLabel;
